import React from 'react';
import CookieAlert from './cookies';
import { render } from 'react-dom';

export const CookieNotification = element => {
    render(<CookieAlert />, element);
};
